import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';
import { environment } from '../../../environments/environment';
import { RequestDto } from '../../models/request.dto';
import { AuthService } from '../../services/auth.service';
import { StructureService } from '../../services/structure.service';
import { ContextService } from '../../services/context.service';

interface Actor {
  id: string;
  code: string;
  name: string;
}

interface Asl {
  id: number;
  code: string;
  name: string;
  cots: any[];
  wards: any[];
  uvmTypes: any[];
  puas: any[];
  bedManagers: any[];
}

@Component({
  selector: 'app-change-ownership',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './change-ownership.component.html',
  styleUrl: './change-ownership.component.scss',
})
export class ChangeOwnershipComponent {
  initialOwnershipId: string | null = null;

  @Output() changeConfirmed = new EventEmitter<{ actorId: string; ownershipId: string }>();
  @Output() cancelled = new EventEmitter<void>();
  @Input() request: RequestDto | undefined;
  @Input() isConsentMissing: boolean | undefined;

  actors: Actor[] = [];
  asls: Asl[] = [];
  ownerships: any[] = [];
  filteredOwnerships: any[] = [];

  uvm: boolean = false;
  cot: boolean = false;
  ward: boolean = false;
  pua: boolean = false;
  bedManager: boolean = false;

  selectedAslId: number | null = null;
  selectedOwnershipId: any | null = null;

  searchTerm: string = '';

  constructor(private http: HttpClient, public authService: AuthService, private structureService: StructureService, private contextService: ContextService) {}

  ngOnInit(): void {
    this.loadActors();
    this.loadAsls();
  }

  setChangeOwnership() {
    this.structureService.getWardInfo(this.contextService.getSelected('ward')!.code).subscribe(result => {
      this.cot = true;
      this.selectedAslId = result.asl?.id;
      this.selectedOwnershipId = { ...result.cot, type: 'COT', actorId: 2 };
    });
  }

  loadActors(): void {
    this.http.get<Actor[]>(`${environment.beServiceUrl}/v1/actor/find`).subscribe((data) => {
      this.actors = data;
    });
  }

  loadAsls(): void {
    this.http.get<Asl[]>(`${environment.beServiceUrl}/v1/asl/find-details`).subscribe((data) => {
      this.asls = data;
      if(this.authService.isOperatoreSegnalante) {
        this.setChangeOwnership();
      }
    });
  }

  onAslOrActorChange(): void {
    if(!this.authService.isOperatoreSegnalante) {
      this.selectedOwnershipId = null;
    }
    this.loadOwnerships();
  }

  loadOwnerships(): void {
    if(this.authService.isOperatoreSegnalante) {
      this.cot = true;
    }
    this.ownerships = [];
    const selectedAsl = this.asls.find((asl) => asl.id == this.selectedAslId);
    if (!selectedAsl) return;

    if (this.cot && this.authService.isOperatoreSegnalante) {
        this.ownerships.push(this.selectedOwnershipId)
    } else if (this.cot) {
      selectedAsl.cots.forEach((c) =>
        this.ownerships.push({ ...c, type: 'COT', actorId: 2 })
      );
    }

    if (this.uvm) {
      if(this.request?.setting.code == 'HCP') {
        selectedAsl.uvmTypes.filter(u => u.category?.code == 'UVCP').forEach((u) =>
        this.ownerships.push({ ...u, type: 'UVCP', actorId: 1 })
      );
      } else {
        selectedAsl.uvmTypes.filter(u => u.category?.code == 'UVM').forEach((u) =>
        this.ownerships.push({ ...u, type: 'UVM', actorId: 1 })
      );
      }
      
    }

    if (this.ward) {
      selectedAsl.wards.forEach((w) =>
        this.ownerships.push({ ...w, type: 'REPARTO', actorId: 3 })
      );
    }

    if (this.pua) {
      selectedAsl.puas.forEach((p) =>
        this.ownerships.push({ ...p, type: 'PUA', actorId: 5 })
      );
    }

    if (this.bedManager) {
      selectedAsl.bedManagers.forEach((b) =>
        this.ownerships.push({ ...b, type: 'BM', actorId: 4 })
      );
    }
    this.filterOwnerships();
  }

  filterOwnerships(): void {
    const term = this.searchTerm.toLowerCase();
    this.filteredOwnerships = this.ownerships.filter(
      (item) =>
        item.name.toLowerCase().includes(term) ||
        item.type.toLowerCase().includes(term)
    );
  }

  resetFilter(): void {
    this.searchTerm = '';
    this.filterOwnerships();
  }

  selectOwnership(ownership: any): void {
    if(!this.authService.isOperatoreSegnalante) {
      this.selectedOwnershipId = ownership;
    }
  }

  confirm(): void {
    if (this.selectedOwnershipId) {
      this.changeConfirmed.emit({
        actorId: this.selectedOwnershipId.actorId.toString(),
        ownershipId: this.selectedOwnershipId.id.toString(),
      });
    }
  }

  cancel(): void {
    this.cancelled.emit();
  }
}
